var _desc, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagOfGermany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 600,
    viewBox: "0 0 5 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flag of Germany")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "black_stripe",
    width: 5,
    height: 3,
    y: 0,
    x: 0,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "red_stripe",
    width: 5,
    height: 2,
    y: 1,
    x: 0,
    fill: "#D00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "gold_stripe",
    width: 5,
    height: 1,
    y: 2,
    x: 0,
    fill: "#FFCE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfGermany);
export default __webpack_public_path__ + "static/media/Flag_of_Germany.67bf05d44fa6e5f851120f9f5bddde90.svg";
export { ForwardRef as ReactComponent };